import { Modal as bsModal } from 'bootstrap';

class CheckoutExtra {

    constructor(el) {
        this.el = el;
        this.productId = this.el.dataset.extrasProductId;
        this.modalTrigger = this.el.querySelector('button[data-extras-modal-btn]');
        this.mode = this.modalTrigger.dataset.extrasModalBtn;
        // behaviour
        this.modalTrigger.onclick = (e) => {
            this.openModal(e);
        };
    }

    openModal(e) {
        // set loading content
        modalBody.innerHTML = loadingHTML;
        // open modal
        modal.show();
        // load dynamic modal content
        let contentURL = window.extrasModalDataEndpoint;

        if (e.currentTarget.dataset.extrasUrl) {
            contentURL = e.currentTarget.dataset.extrasUrl;
        }

        // get content and update modal div html
        getModalContent(contentURL).then((newHTML) => {
            modalBody.innerHTML = newHTML;

            const calendarBookingElements = document.querySelectorAll('.js-calendar-booking');

            if (calendarBookingElements.length) {
                import('./calendarBookingApi').then(({ default: CalendarBookingApi }) => {
                    calendarBookingElements.forEach(calendarBookingElement => {
                        new CalendarBookingApi(calendarBookingElement);
                    });
                });
            }

            const forms = modalBody.querySelectorAll('form');

            if (forms.length) {
                forms.forEach(form => {
                    form.action = location.pathname;
                });
            }
        });
    }

    closeModal() {
        modal.hide();
    }
}

// Function to load modal content
async function getModalContent(contentURL) {
    let detailHTML = await (await window.fetch(contentURL, {
        method: 'POST'
    })).text();
    return detailHTML;
}

// initialize modal in Bootstrap5
let modal, modalBody;

const loadingHTML = '<div class="panel theme--white p-3 p-lg-4"><div class="checkout--extras--modal--header"><h1 class="h2 m-0"><i class="fa-solid fa-sync fa-fw fa-spin"></i> Loading...</h1><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div></div>';

// export the default function to create
export function createFrom(wrappers) {

    // find the in-page modal first
    let findModal = document.querySelector('#checkout-extras-modal');
    if (findModal != null) {
        modal = bsModal.getOrCreateInstance(findModal);
        modalBody = findModal.querySelector('.modal-body');
        // clear modal content when it closes
        findModal.addEventListener('hidden.bs.modal', () => {
            modalBody.innerHTML = '';
        });

        wrappers.forEach((node) => {
            // if node is an element
            if (node.nodeType === 1) {
                let modalTrigger = node.querySelector('button[data-extras-modal-btn]');
                if (modalTrigger) {
                    new CheckoutExtra(node);
                }
            }
        });

    }

}